import _ from 'lodash';
import ServiceRequestRouteConfig from 'edge/servicerequest/config/RouteConfig';
import ServiceRequestService from 'edge/servicerequest/services/ServiceRequestService';
import ServiceRequestDocumentService from 'edge/servicerequest/services/ServiceRequestDocumentService';
import ServiceRequestMessageList from 'edge/servicerequest/directives/ServiceRequestMessageList';
import ServiceRequestDocuments from 'edge/servicerequest/directives/ServiceRequestDocuments';
import ServiceRequestStatementDocuments from 'edge/servicerequest/directives/ServiceRequestStatementDocuments';
import ServiceRequestHistory from 'edge/servicerequest/directives/ServiceRequestHistory';
import GlobalMessagesTemplate from 'text!./directives/templates/service-request-global-message-list.html';
import 'edge/platform/base/module';
import 'edge/platform/widgets/documentupload/module';
import 'edge/platform/widgets/inputs/module';
import 'edge/platform/widgets/basicinputs/module';
import 'edge/platform/widgets/loading/module';
import 'edge/platform/widgets/modal/module';
import 'edge/platform/widgets/table/module';
import 'edge/platform/navigation/module';
import 'edge/platform/widgets/datetimepicker/module';
import 'edge/platform/widgets/accordion/module';
import 'gw-portals-viewmodel-angular';
import 'gw-portals-viewmodel-angular/aspects/module';
import 'angularRouter';
import 'portalConfig';
// noinspection UnnecessaryLocalVariableJS
const appModule = angular.module('edge.servicerequest.app', [
    'portal.config',
    'edge.platform.base',
    'edge.platform.widgets.documentupload',
    'ui.router',
    'edge.platform.widgets.loadingMsg',
    'edge.platform.widgets.modal',
    'edge.platform.widgets.inputs',
    'edge.platform.widgets.basicinputs',
    'edge.platform.widgets.table',
    'edge.platform.navigation',
    'edge.platform.widgets.ui.bootstrap.datetimepicker',
    'edge.platform.widgets.ui.bootstrap.accordion',
    'gw-portals-viewmodel-angular',
    'gw-portals-viewmodel-angular.aspects'
])


    .config(['$stateProvider', 'state_plugin_config', ($stateProvider, RootStateConfig) => {
        const states = new ServiceRequestRouteConfig(RootStateConfig);
        _.values(states).forEach((state) => {
            $stateProvider.state(state);
        });
    }])


    .factory('servicerequest.ServiceRequestService', ServiceRequestService)
    .factory('servicerequest.ServiceRequestDocumentService', ServiceRequestDocumentService)

    .directive('gwServiceRequestMessageList', ServiceRequestMessageList)
    .directive('gwServiceRequestDocuments', ServiceRequestDocuments)
    .directive('gwServiceRequestStatementDocuments', ServiceRequestStatementDocuments)
    .directive('gwServiceRequestHistory', ServiceRequestHistory)

    .constant('globalMessagesTemplate', GlobalMessagesTemplate);

export default appModule;